<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<!---------------------- To Do ---------------------->

<div class="dash" *ngIf="todo">
  <div [class.spinner]="todoloading"></div>
  <form action="" [formGroup]="todoForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search">
            <input type="text" #newid (keyup)="onInputChange(newid.value, 'todo')" [disabled]="isSearchDisabled"
              placeholder="Search Trip ID" (input)="transformToUppercaseTodo($event)"
              (keyup.enter)="todoSearch(newid.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }"
              (click)="!isSearchDisabled && todoSearch(newid.value)" alt="" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('todo')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedTodo">
          <a (click)="reportadvanced('todo')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportCloseTodo">
          <a (click)="reportClose('todo')">Close</a>
        </div>
      </div>

      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker1" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <input matInput [matDatepicker]="picker1" placeholder="From" formControlName="from_date"
                (click)="picker1.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker2" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <input matInput [matDatepicker]="picker2" placeholder="To" formControlName="to_date"
                (click)="picker2.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Trip Status" formControlName="trip_status">
                <mat-option *ngFor="let tripstatus of filteredTripStatus" value="{{ tripstatus }}">{{ tripstatus
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Trip ID" formControlName="trip_id">
                <mat-option *ngFor="let trip of masterList.tripNumbers" value="{{ trip }}">{{ trip }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Bank Name" formControlName="bank_name">
                <mat-option *ngFor="let bankname of masterList.truckownerBankName" value="{{ bankname }}">{{ bankname
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Truck NO" formControlName="truck_no">
                <mat-option *ngFor="let vehicle of masterList.truck_data" value="{{ vehicle }}">{{ vehicle
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="tododownloadPdf(tododownloadArray)" [class.disabled]="todoArray && todoArray.length === 0"
              [attr.disabled]="
                todoArray && todoArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  todoArray && todoArray.length === 0 ? 'none' : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="tododownloadXl(tododownloadArray)" [class.disabled]="todoArray && todoArray.length === 0"
              [attr.disabled]="
                todoArray && todoArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  todoArray && todoArray.length === 0 ? 'none' : 'auto'
              }">XLSX</a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="resetTodo()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applyTodoFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }" (click)="getActiveTab('corporatecustomers')">C
          C</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>

    <div class="table-container" *ngIf="todoReport">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="1">Date</td>
            <td rowspan="1">Trip ID</td>
            <td rowspan="1">Trip Status</td>
            <td rowspan="1">Truck No</td>
            <td rowspan="1">Account Name</td>
            <td rowspan="1">Account No</td>
            <td rowspan="1">IFSC Code</td>
            <td rowspan="1">Bank Name</td>
            <td rowspan="1">Amount</td>
          </tr>
          <tr *ngFor="let todo of todoArray">
            <td>{{ todo.pickup_date | date : "dd-MM-yyyy" }}</td>
            <td>{{ todo.trip_id }}</td>
            <!-- <td>{{ todo.trip_status | uppercase }}</td> -->
            <td>
              <ng-container *ngIf="todo?.workorderInfo?.length === 0; else checkTripHistory">
                {{
                todo?.trip_status
                ? todo.trip_status.charAt(0).toUpperCase() +
                todo.trip_status.slice(1).toLowerCase()
                : ""
                }}
              </ng-container>

              <ng-template #checkTripHistory>
                <ng-container *ngIf="
                    (todo?.workorderInfo?.length > 0 &&
                      [
                        'started_to_pickup_location',
                        'pickup_location',
                        'trip_start',
                        'drop_location',
                        'unloading_done',
                        'loading_done',
                        'pod_submission',
                        'trip_end'
                      ].includes(
                        todo?.trip_history[todo?.trip_history?.length - 1]?.name
                      ) &&
                      (todo?.trip_history[todo?.trip_history?.length - 1]
                        ?.is_verified === 0 ||
                        todo?.trip_history[todo?.trip_history?.length - 1]
                          ?.is_verified == null)) ||
                      todo?.trip_history?.length === 0;
                    else checkLoadingDone
                  ">
                  {{
                  todo?.trip_status
                  ? todo.trip_status.charAt(0).toUpperCase() +
                  todo.trip_status.slice(1).toLowerCase()
                  : ""
                  }}
                </ng-container>
              </ng-template>

              <ng-template #checkLoadingDone>
                <ng-container *ngIf="
                    todo?.trip_history?.length > 0 &&
                      todo?.tripPaymentInfo?.length === 0 &&
                      todo?.trip_history[todo?.trip_history?.length - 1]
                        ?.name === 'loading_done' &&
                      todo?.trip_history[todo?.trip_history?.length - 1]
                        ?.is_verified !== 0;
                    else checkPOD
                  ">
                  Loading Done
                </ng-container>
              </ng-template>

              <ng-template #checkPOD>
                <ng-container *ngIf="
                    todo?.trip_history?.length > 0 &&
                    todo?.tripPaymentInfo?.length === 0 &&
                    ((todo?.trip_history[todo?.trip_history?.length - 1]
                      ?.name === 'pod_submission' &&
                      todo?.trip_history[todo?.trip_history?.length - 1]
                        ?.is_verified != 0) ||
                      todo?.trip_history[todo?.trip_history?.length - 1]
                        ?.is_verified == null)
                  ">
                  POD
                </ng-container>
              </ng-template>
            </td>

            <td>
              {{
              todo.truckInfo[0]?.truck_number || todo.truckInfo?.truck_number
              }}
            </td>
            <td>
              {{
              todo.truckOwnerInfo[0]?.account_details?.account_name ||
              todo.truckOwnerInfo?.account_details?.account_name
              }}
            </td>
            <td>
              {{
              todo.truckOwnerInfo[0]?.account_details?.accountr_number ||
              todo.truckOwnerInfo?.account_details?.accountr_number
              }}
            </td>
            <td>
              {{
              todo.truckOwnerInfo[0]?.account_details?.ifsc_code ||
              todo.truckOwnerInfo?.account_details?.ifsc_code
              }}
            </td>
            <td>
              {{
              todo.truckOwnerInfo[0]?.account_details?.bank_name ||
              todo.truckOwnerInfo?.account_details?.bank_name
              }}
            </td>

            <td>
              <ng-container *ngIf="todo?.tripPaymentInfo?.length > 0; else workOrderCheck">
                <ng-container *ngIf="
                    todo.tripPaymentInfo[0]?.price_details?.payment_history
                      ?.length > 1;
                    else showFirstPayment
                  ">
                  <ng-container *ngIf="
                      todo.tripPaymentInfo[0].price_details.payment_history
                        .length > 2;
                      else showSecondPayment
                    ">
                    {{
                    (
                    (todo.tripPaymentInfo[0].price_details
                    .payment_history[1]?.amount_paid || 0) +
                    (todo.tripPaymentInfo[0].price_details
                    .payment_history[2]?.amount_paid || 0)
                    ).toFixed(2)
                    }}
                  </ng-container>

                  <ng-template #showSecondPayment>
                    {{
                    (
                    todo.tripPaymentInfo[0].price_details.payment_history[1]
                    ?.amount_paid || 0
                    ).toFixed(2)
                    }}
                  </ng-template>
                </ng-container>

                <ng-template #showFirstPayment>
                  {{ (0).toFixed(2) }}
                </ng-template>
              </ng-container>

              <ng-template #workOrderCheck>
                <ng-container *ngIf="
                    todo?.workorderInfo?.length > 0 &&
                      todo.trip_status != 'tripbooked';
                    else noWorkOrder
                  ">
                  <ng-container *ngIf="
                      todo?.workorderInfo?.length > 0 &&
                      [
                        'started_to_pickup_location',
                        'pickup_location',
                        'loading_done'
                      ].includes(
                        todo?.trip_history[todo?.trip_history?.length - 1]?.name
                      ) &&
                      (todo?.trip_history[todo?.trip_history?.length - 1]
                        ?.is_verified === 0 ||
                        todo?.trip_history[todo?.trip_history?.length - 1]
                          ?.is_verified == null)
                    ">
                    {{ (0).toFixed(2) }}
                  </ng-container>

                  <ng-container *ngIf="
                      (todo?.workorderInfo?.length > 0 &&
                        [
                          'loading_done',
                          'trip_start',
                          'drop_location',
                          'pod_submission'
                        ].includes(
                          todo?.trip_history[todo?.trip_history?.length - 1]
                            ?.name
                        ) &&
                        (todo?.trip_history[todo?.trip_history?.length - 1]
                          ?.is_verified !== 0 ||
                          todo?.trip_history[todo?.trip_history?.length - 1]
                            ?.is_verified == null)) ||
                        todo?.trip_history?.length === 0;
                      else checkPODAmount
                    ">
                    {{
                    (
                    (todo.workOrderOtherDetails?.loading_point || 0) *
                    (todo.workOrderOtherDetails?.price_per_ton || 0) *
                    0.9
                    ).toFixed(2)
                    }}
                  </ng-container>

                  <ng-template #checkPODAmount>
                    <ng-container *ngIf="
                        todo?.trip_history?.length > 0 &&
                        todo?.tripPaymentInfo?.length === 0 &&
                        todo?.trip_history[todo?.trip_history?.length - 1]
                          ?.name === 'pod_submission' &&
                        (todo?.trip_history[todo?.trip_history?.length - 1]
                          ?.is_verified !== 0 ||
                          todo?.trip_history[todo?.trip_history?.length - 1]
                            ?.is_verified == null)
                      ">
                      {{
                      (
                      (todo.workOrderOtherDetails?.loading_point || 0) *
                      (todo.workOrderOtherDetails?.price_per_ton || 0) *
                      0.1
                      ).toFixed(2)
                      }}
                    </ng-container>
                  </ng-template>

                  <ng-container *ngIf="
                      todo?.trip_history?.length > 0 &&
                      todo?.tripPaymentInfo?.length === 0 &&
                      todo?.trip_history[todo?.trip_history?.length - 1]
                        ?.name === 'trip_end'
                    ">
                    {{
                    (
                    (todo.workOrderOtherDetails?.loading_point || 0) *
                    (todo.workOrderOtherDetails?.price_per_ton || 0)
                    ).toFixed(2)
                    }}
                  </ng-container>
                </ng-container>

                <ng-template #noWorkOrder>
                  {{ (0).toFixed(2) }}
                </ng-template>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row to_container" *ngIf="!todoArray?.length && !todoloading">
      <h4 class="error_msg">No Records Found.</h4>
    </div>
  </form>
  <div *ngIf="last_page && last_page > 1 && todoReport" class="pagination">
    <button class="btn" [disabled]="todo_fetch_page == 1" (click)="todopagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="todo_fetch_page == 1" (click)="todopagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="todo_fetch_page > 0">{{ todo_fetch_page }}</a>
    </div>
    <button class="btn" [disabled]="last_page == todo_fetch_page" (click)="todopagination('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == todo_fetch_page" (click)="todopagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!---------------------- Quotes ---------------------->

<div class="dash" *ngIf="quotes">
  <div [class.spinner]="quotesloading"></div>
  <form action="" [formGroup]="quotesForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search" style="position: relative">
            <input type="text" #newItem (keyup)="onInputChange(newItem.value, 'quotes')" [disabled]="isSearchDisabled"
              placeholder="Search Quotes ID" (input)="transformToUppercaseQuote($event)"
              (keyup.enter)="quoteSearch(newItem.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }"
              (click)="!isSearchDisabled && quoteSearch(newItem.value)" alt="" style="
                position: absolute;
                right: 40px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
              " />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('quotes')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedQuotes">
          <a (click)="reportadvanced('quotes')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportCloseQuote">
          <a (click)="reportClose('quotes')">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker1" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <input matInput [matDatepicker]="picker1" placeholder="From" formControlName="from_date"
                (click)="picker1.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker2" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <input matInput [matDatepicker]="picker2" placeholder="To" formControlName="to_date"
                (click)="picker2.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="From Location" formControlName="from_loc">
                <mat-option *ngFor="let fromloc of masterList.fromCityDetail" value="{{ fromloc }}">{{ fromloc
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="To Location" formControlName="to_loc">
                <mat-option *ngFor="let toloc of masterList.toCityDetail" value="{{ toloc }}">{{ toloc }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Quote ID" formControlName="quote_id">
                <mat-option *ngFor="let quote of masterList.tripNumbers" value="{{ quote }}">{{ quote }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Truck Category" formControlName="truck_categ">
                <mat-option *ngFor="let truckcat of masterList.truck_category" value="{{ truckcat }}">{{ truckcat
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>

          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a [class.disabled]="quotesArray && quotesArray.length === 0" [attr.disabled]="
                quotesArray && quotesArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  quotesArray && quotesArray.length === 0 ? 'none' : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="downloadXl(downloadArray)" [class.disabled]="quotesArray && quotesArray.length === 0"
              [attr.disabled]="
                quotesArray && quotesArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  quotesArray && quotesArray.length === 0 ? 'none' : 'auto'
              }">XLSX</a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="resetQuotes()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applyQuoteFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>
    <div class="table-container" *ngIf="quotesReport">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="1">Date</td>
            <td rowspan="1">Quote ID</td>
            <td rowspan="1">From</td>
            <td rowspan="1">To</td>
            <td rowspan="1">Truck Category</td>
            <td rowspan="1">Weight</td>
            <!-- <td rowspan="1">Load</td> -->
            <td rowspan="1">Contact No</td>
            <td rowspan="1">Status</td>
          </tr>
          <tr *ngFor="let quotes of quotesArray">
            <td>{{ quotes.pickup_date | date : "dd-MM-yyyy" }}</td>
            <td>{{ quotes.trip_id }}</td>
            <td>{{ quotes.pickup_details.from_city_name }}</td>
            <td>{{ quotes?.dropoff_details.to_city_name }}</td>
            <td>{{ quotes?.truckCategoryInfo?.truck_category_name }}</td>
            <td>
              {{
              quotes?.truckTypeInfo ? quotes?.truckTypeInfo?.truck_weight : ""
              }}
            </td>
            <!-- <td>{{ quotes?.load_type }}</td> -->
            <td>{{ quotes.userInfo.mobile }}</td>
            <td style="text-transform: capitalize">
              {{ quotes?.trip_status }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
  <div class="row to_container" *ngIf="!quotesArray?.length && !quotesloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div *ngIf="last_page && last_page > 1 && quotesReport" class="pagination">
    <button class="btn" [disabled]="fetch_page == 1" (click)="quotespagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="fetch_page == 1" (click)="quotespagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
    </div>
    <button class="btn" [disabled]="last_page == fetch_page" (click)="quotespagination('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == fetch_page" (click)="quotespagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!---------------------- Trips ---------------------->

<div class="dash" *ngIf="trips">
  <div [class.spinner]="tripsloading"></div>
  <form action="" [formGroup]="tripsForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search">
            <input type="text" #tripsTab (keyup)="onInputChange(tripsTab.value, 'trips')" [disabled]="isSearchDisabled"
              placeholder="Search Trip ID" (input)="transformToUppercaseTrips($event)"
              (keyup.enter)="tripsSearch(tripsTab.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }"
              (click)="!isSearchDisabled && tripsSearch(tripsTab.value)" alt="" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('trips')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedTrips">
          <a (click)="reportadvanced('trips')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportCloseTrips">
          <a (click)="reportClose('trips')">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-2">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker1" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <input matInput [matDatepicker]="picker1" placeholder="From" formControlName="from_date"
                (click)="picker1.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker2" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <input matInput [matDatepicker]="picker2" placeholder="To" formControlName="to_date"
                (click)="picker2.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="From Location" formControlName="from_loc">
                <mat-option *ngFor="let fromloc of masterList.fromCityDetail" value="{{ fromloc }}">{{ fromloc
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="To Location" formControlName="to_loc">
                <mat-option *ngFor="let toloc of masterList.toCityDetail" value="{{ toloc }}">{{ toloc }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Trip ID" formControlName="trip_id">
                <mat-option *ngFor="let trip of masterList.tripNumbers" value="{{ trip }}">{{ trip }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Vehicle No" formControlName="vehcl_no">
                <mat-option *ngFor="let vehicle of masterList.truck_data" value="{{ vehicle }}">{{ vehicle
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Vehicle Category" formControlName="veh_cat">
                <mat-option *ngFor="let vehcat of masterList.truck_category" value="{{ vehcat }}">{{ vehcat
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Weight" formControlName="weight">
                <mat-option *ngFor="let truckweight of masterList.truck_weight" value="{{ truckweight }}">{{ truckweight
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Trip Status" formControlName="trip_status">
                <mat-option *ngFor="let tripstatus of filteredTripStatus" value="{{ tripstatus }}">{{ tripstatus
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a [class.disabled]="tripsArray && tripsArray.length === 0" [attr.disabled]="
                tripsArray && tripsArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  tripsArray && tripsArray.length === 0 ? 'none' : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="tripdownloadXl(tripsdownloadArray)" [class.disabled]="tripsArray && tripsArray.length === 0"
              [attr.disabled]="
                tripsArray && tripsArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  tripsArray && tripsArray.length === 0 ? 'none' : 'auto'
              }">
              XLSX
            </a>
          </div>

          <div class="col-md-2">
            <button class="reset_btn" (click)="resetTrips()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applyTripsFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>
    <div class="table-container" *ngIf="tripsReport">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="2">Date</td>
            <td rowspan="2">Trip ID</td>
            <td rowspan="2">From</td>
            <td rowspan="2">To</td>
            <td rowspan="2">User Type</td>
            <td colspan="4">Vehicle Details</td>
            <td colspan="3">Trip</td>
            <td rowspan="2">Trip Status</td>
          </tr>
          <tr>
            <td>Vehicle No</td>
            <td>Category</td>
            <td>Weight</td>
            <td>Feet</td>
            <td>Total Amount</td>
            <td>Paid</td>
            <td>Balance</td>
          </tr>
          <tr *ngFor="let trips of tripsArray">
            <td>{{ trips.pickup_date | date : "dd-MM-yyyy" }}</td>
            <td>{{ trips.trip_id }}</td>
            <td>{{ trips.pickup_details?.from_city_name }}</td>
            <td>{{ trips.dropoff_details?.to_city_name }}</td>
            <td>
              {{
              trips?.userInfo?.user_type === "customer"
              ? "RC"
              : trips?.userInfo?.user_type === "corporate"
              ? "CC"
              : "N/A"
              }}
            </td>
            <td>
              {{
              trips.truckInfo[0]?.truck_number ||
              trips.truckInfo?.truck_number
              }}
            </td>
            <td>
              {{
              trips.truckCategoryInfo[0]?.truck_category_name ||
              trips.truckCategoryInfo?.truck_category_name
              }}
            </td>
            <td>
              {{
              trips.truckTypeInfo[0]?.truck_weight ||
              trips.truckTypeInfo?.truck_weight
              }}
            </td>
            <td>
              {{
              trips.truckTypeInfo[0]?.truck_feet ||
              trips.truckTypeInfo?.truck_feet
              }}
            </td>
            <td *ngIf="trips?.userInfo?.user_type === 'customer'">
              {{ (trips?.tripPaymentInfo?.[0]?.price_details?.total_amount || 0).toFixed(2) }}
            </td>

            <td *ngIf="trips?.userInfo?.user_type === 'corporate'">
              {{
              trips?.workorderInfo?.[0]?.pay_as_load_quantity === 'unloaded_quantity'
              ? ((trips?.workorderInfo?.[0]?.price_per_ton *
              (trips?.workOrderOtherDetails?.unloading_point || 0)).toFixed(2))
              : trips?.workorderInfo?.[0]?.pay_as_load_quantity === 'loaded_quantity'
              ? ((trips?.workorderInfo?.[0]?.price_per_ton *
              (trips?.workOrderOtherDetails?.loading_point || 0)).toFixed(2))
              : 'N/A'
              }}
            </td>

            <td *ngIf="trips?.userInfo?.user_type === 'customer'">
              {{
              (
              (trips?.tripPaymentInfo?.[0]?.price_details?.payment_history[1]?.amount_paid || 0) +
              (trips?.tripPaymentInfo?.[0]?.price_details?.payment_history[2]?.amount_paid || 0)
              ).toFixed(2)
              }}
            </td>

            <td *ngIf="trips?.userInfo?.user_type === 'corporate'">
              {{
              trips?.workorderInfo?.[0]?.pay_as_load_quantity === 'unloaded_quantity'
              ? (trips?.workorderInfo?.[0]?.price_per_ton *
              (trips?.workOrderOtherDetails?.unloading_point || 0)).toFixed(2)
              : trips?.workorderInfo?.[0]?.pay_as_load_quantity === 'loaded_quantity'
              ? (trips?.workorderInfo?.[0]?.price_per_ton *
              (trips?.workOrderOtherDetails?.loading_point || 0)).toFixed(2)
              : 'N/A'
              }}
            </td>

            <td *ngIf="trips?.userInfo?.user_type === 'customer'">
              {{
              (
              (trips?.tripPaymentInfo?.[0]?.price_details?.total_amount || 0) -
              ((trips?.tripPaymentInfo?.[0]?.price_details?.payment_history[1]?.amount_paid || 0) +
              (trips?.tripPaymentInfo?.[0]?.price_details?.payment_history[2]?.amount_paid || 0))
              ).toFixed(2)
              }}
            </td>

            <td *ngIf="trips?.userInfo?.user_type === 'corporate'">
              <!-- {{
                trips?.workorderInfo?.[0]?.pay_as_load_quantity === 'unloaded_quantity'
                  ? (trips?.workorderInfo?.[0]?.price_per_ton *
                      (trips?.workOrderOtherDetails?.unloading_point || 0)).toFixed(2)
                  : trips?.workorderInfo?.[0]?.pay_as_load_quantity === 'loaded_quantity'
                  ? (trips?.workorderInfo?.[0]?.price_per_ton *
                      (trips?.workOrderOtherDetails?.loading_point || 0)).toFixed(2)
                  : 'N/A'
              }} -->
              {{ (0).toFixed(2) }}
            </td>

            <td>
              {{
              trips.trip_status
              ? trips.trip_status.charAt(0).toUpperCase() +
              trips.trip_status.slice(1).toLowerCase()
              : ""
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>

  <div class="row to_container" *ngIf="!tripsArray?.length && !tripsloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div *ngIf="last_page && last_page > 1 && tripsReport" class="pagination">
    <button class="btn" [disabled]="trips_fetch_page == 1" (click)="tripspagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="trips_fetch_page == 1" (click)="tripspagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="trips_fetch_page > 0">{{ trips_fetch_page }}</a>
    </div>
    <button class="btn" [disabled]="last_page == trips_fetch_page" (click)="tripspagination('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == trips_fetch_page" (click)="tripspagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!---------------------- Payments ---------------------->

<div class="dash" *ngIf="payments">
  <div [class.spinner]="paymentsloading"></div>
  <form action="" [formGroup]="paymentsForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search">
            <input type="text" #paymentTab (keyup)="onInputChange(paymentTab.value, 'payments')"
              [disabled]="isSearchDisabled" placeholder="Search Trip ID" (input)="transformToUppercasePayments($event)"
              (keyup.enter)="paymentSearch(paymentTab.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }"
              (click)="!isSearchDisabled && paymentSearch(paymentTab.value)" alt="" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('payments')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedPayments">
          <a (click)="reportadvanced('payments')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportClosePayments">
          <a (click)="reportClose('payments')">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker1" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <input matInput [matDatepicker]="picker1" placeholder="From" formControlName="from_date"
                (click)="picker1.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker2" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <input matInput [matDatepicker]="picker2" placeholder="To" formControlName="to_date"
                (click)="picker2.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="From Location" formControlName="from_loc">
                <mat-option *ngFor="let fromloc of masterList.fromCityDetail" value="{{ fromloc }}">{{ fromloc
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="To Location" formControlName="to_loc">
                <mat-option *ngFor="let toloc of masterList.toCityDetail" value="{{ toloc }}">{{ toloc }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Trip ID" formControlName="trip_id">
                <mat-option *ngFor="let trip of masterList.tripNumbers" value="{{ trip }}">{{ trip }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Status" formControlName="payment_status">
                <mat-option *ngFor="let trip of masterList.trip_status" value="{{ trip }}">{{ trip }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a [class.disabled]="paymentsArray && paymentsArray.length === 0" [attr.disabled]="
                paymentsArray && paymentsArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  paymentsArray && paymentsArray.length === 0 ? 'none' : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="paymentdownloadXl(paymentdownloadArray)"
              [class.disabled]="paymentsArray && paymentsArray.length === 0" [attr.disabled]="
                paymentsArray && paymentsArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  paymentsArray && paymentsArray.length === 0 ? 'none' : 'auto'
              }">XLSX</a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="paymentReset()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applyPaymentsFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>
    <div class="row" *ngIf="paymentsReport">
      <div class="col-md-6">
        <div class="left-side-bar">
          <p>Customer Receivables</p>
          <div class="row ml-0 mr-0">
            <div class="col-md-12">
              <div class="card-details card-details-total">
                <div class="trip-details-left">Total Receivable</div>
                <div class="trip-details-right">
                  ₹ {{ paymentData?.customer_payments.total_receivable }}
                </div>
                <div>Deductions</div>
                <div *ngFor="let tax of paymentGst">
                  <div class="trip-details-left">
                    {{ tax.tax_name }} ({{ tax.tax_deduction }}
                    {{ tax.tax_type == "percent" ? "%" : "" }})
                  </div>

                  <div class="trip-details-right" *ngIf="tax.tax_type == 'percent'">
                    ₹
                    {{ (customer_total_receivable * tax.tax_deduction) / 100 }}
                  </div>
                  <!-- <div class="trip-details-left">S9 Service Fee</div>
                  <div class="trip-details-right">₹ 1,50,000</div>  
                  <div class="trip-details-left">S9 GST</div>
                  <div class="trip-details-right">₹ 27,000</div> -->
                </div>
              </div>
              <div class="trip-details-left">Actual Receivable</div>
              <div class="trip-details-right">₹ {{ round_amount }}</div>
              <div class="trip-details-left">S9 Paid</div>
              <div class="trip-details-right">
                ₹ {{ paymentData?.customer_payments?.s9_payment }}
              </div>

              <div class="trip-details-left">Balance Amount</div>
              <div class="trip-details-right">
                ₹
                {{ round_amount - paymentData?.customer_payments?.s9_payment }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="left-side-bar">
          <p>Transporter Payments</p>
          <div class="row ml-0 mr-0">
            <div class="col-md-12">
              <div class="card-details card-details-total">
                <div class="trip-details-left">Total Receivable</div>
                <div class="trip-details-right">
                  ₹ {{ paymentData?.truckowner_payments?.total_receivable }}
                </div>
                <div>Deductions</div>
                <div *ngFor="let tax of paymnetTransGST">
                  <div class="trip-details-left">
                    {{ tax.tax_name }} ({{ tax.tax_deduction }}
                    {{ tax.tax_type == "percent" ? "%" : "" }})
                  </div>
                  <div class="trip-details-right" *ngIf="tax.tax_type == 'percent'">
                    ₹ {{ (trans_total_receivable * tax.tax_deduction) / 100 }}
                  </div>
                  <!-- <div class="trip-details-left">S9 Service Fee</div>
                      <div class="trip-details-right">₹ 1,50,000</div>
                    <div class="trip-details-left">S9 GST</div>
                    <div class="trip-details-right">₹ 27,000</div> -->
                </div>
              </div>
              <div class="trip-details-left">Actual Receivable</div>
              <div class="trip-details-right">₹ {{ trans_round_amount }}</div>
              <div class="trip-details-left">S9 Paid</div>
              <div class="trip-details-right">
                ₹ {{ paymentData?.truckowner_payments?.s9_payment }}
              </div>
              <div class="trip-details-left">Balance Amount</div>
              <div class="trip-details-right">
                ₹
                {{
                trans_round_amount -
                paymentData?.truckowner_payments?.s9_payment
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="paymentsReport">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="2">Date</td>
            <td rowspan="2">Trip ID</td>
            <td rowspan="2">From</td>
            <td rowspan="2">To</td>
            <td colspan="4">Customer Payments</td>
            <td colspan="4">Truck Owner Payment</td>
            <td rowspan="2">Status</td>
          </tr>
          <tr>
            <td>Total Amount</td>
            <td>1st Payment</td>
            <td>2nd Payment</td>
            <td>Due</td>
            <td>Total Amount</td>
            <td>1st Payment</td>
            <td>2nd Payment</td>
            <td>Balance</td>
          </tr>
          <tr *ngFor="let payments of paymentsArray">
            <td>{{ payments.pickup_date | date : "dd-MM-yyyy" }}</td>
            <td>{{ payments.trip_id }}</td>
            <td>{{ payments.pickup_details.from_city_name }}</td>
            <td>{{ payments.dropoff_details.to_city_name }}</td>
            <td>
              {{ payments.customerpaymentInfo[0]?.price_details.total_amount }}
            </td>
            <td>
              {{
              payments.customerpaymentInfo[0]?.price_details
              ?.payment_history[1]?.amount_paid ||
              payments.customerpaymentInfo[0]?.price_details
              ?.payment_history[2]?.amount_paid
              }}
            </td>
            <td>
              {{
              payments.customerpaymentInfo[0]?.price_details
              ?.payment_history[2]?.amount_paid ||
              payments.customerpaymentInfo[0]?.price_details
              ?.payment_history[3]?.amount_paid
              }}
            </td>
            <td>
              {{
              payments.customerpaymentInfo[0]?.price_details.total_amount -
              (payments.customerpaymentInfo[0]?.price_details
              ?.payment_history[1]?.amount_paid +
              payments.customerpaymentInfo[0]?.price_details
              ?.payment_history[2]?.amount_paid +
              payments.customerpaymentInfo[0]?.price_details
              ?.payment_history[3]?.amount_paid)
              }}
            </td>
            <td>
              {{
              payments.truckownerpaymentInfo[0]?.transaction_amount +
              payments.truckownerpaymentInfo[1]?.transaction_amount
              }}
            </td>
            <td>{{ payments.truckownerpaymentInfo[0]?.transaction_amount }}</td>
            <td>{{ payments.truckownerpaymentInfo[1]?.transaction_amount }}</td>
            <td></td>
            <!-- <td>{{ payments.trip_status }}</td> -->
            <td>
              {{
              payments.trip_status
              ? payments.trip_status.charAt(0).toUpperCase() +
              payments.trip_status.slice(1).toLowerCase()
              : ""
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>

  <div class="row to_container" *ngIf="!paymentsArray?.length && !paymentsloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div *ngIf="last_page && last_page > 1 && paymentsReport" class="pagination">
    <button class="btn" [disabled]="payment_fetch_page == 1" (click)="paymentspagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="payment_fetch_page == 1" (click)="paymentspagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="payment_fetch_page > 0">{{
        payment_fetch_page
        }}</a>
    </div>
    <button class="btn" [disabled]="last_page == payment_fetch_page" (click)="paymentspagination('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == payment_fetch_page" (click)="paymentspagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!---------------------- Tucks ---------------------->

<div class="dash" *ngIf="trucks">
  <div [class.spinner]="trucksloading"></div>
  <form action="" [formGroup]="trucksForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search">
            <input type="text" #trucksTab (keyup)="onInputChange(trucksTab.value, 'trucks')"
              [disabled]="isSearchDisabled" placeholder="Search Truk Number"
              (input)="transformToUppercaseTrucks($event)" (keyup.enter)="truckSearch(trucksTab.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }"
              (click)="!isSearchDisabled && truckSearch(trucksTab.value)" alt="" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('trucks')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedTrucks">
          <a (click)="reportadvanced('trucks')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportCloseTrucks">
          <a (click)="reportClose('trucks')">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Truck Owner" formControlName="truckowner_name">
                <mat-option *ngFor="let truckowner of masterList.truckonwerDetail" value="{{ truckowner }}">{{
                  truckowner }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Truck Category" formControlName="veh_cat">
                <mat-option *ngFor="let truccat of masterList.truck_category" value="{{ truccat }}">{{ truccat
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="weight" formControlName="weight">
                <mat-option *ngFor="let truckweight of masterList.truck_weight" value="{{ truckweight }}">{{ truckweight
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Feet" formControlName="feet">
                <mat-option *ngFor="let feet of masterList.truck_feet" value="{{ feet }}">{{ feet }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Vehicle Status" formControlName="veh_status">
                <mat-option *ngFor="let vehiclestatus of masterList.truck_status" value="{{ vehiclestatus }}">{{
                  vehiclestatus }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a [class.disabled]="truckArray && truckArray.length === 0" [attr.disabled]="
                truckArray && truckArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  truckArray && truckArray.length === 0 ? 'none' : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="truckdownloadXl(trucksdownloadArray)" [class.disabled]="truckArray && truckArray.length === 0"
              [attr.disabled]="
                truckArray && truckArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  truckArray && truckArray.length === 0 ? 'none' : 'auto'
              }">
              XLSX
            </a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="resetTrucks()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applyTrucksFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>
    <div class="table-container" *ngIf="TrucksReports">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="1">Truck No</td>
            <td rowspan="1">ID</td>
            <td rowspan="1">Category</td>
            <td rowspan="1">Weight</td>
            <td rowspan="1">Feet</td>
            <td rowspan="1">Home Location</td>
            <td rowspan="1">Truck Owner</td>
            <td rowspan="1">Registered on</td>
            <td rowspan="1">Vehicle Status</td>
          </tr>
          <tr *ngFor="let truck of truckArray">
            <td>{{ truck.truck_number }}</td>
            <td>{{ truck.truck_id }}</td>
            <td>{{ truck.truckCategoryInfo?.truck_category_name }}</td>
            <td>{{ truck.truckTypeInfo.truck_weight }}</td>
            <td>{{ truck.truckTypeInfo.truck_feet }}</td>
            <td>{{ truck.home_location }}</td>
            <td>{{ truck.truckOwnerInfo?.username }}</td>
            <td>{{ truck.createdAt | date : "dd-MM-yyyy" }}</td>
            <!-- <td>{{ truck.truck_status }}</td> -->
            <td>
              {{
              truck.truck_status
              ? truck.truck_status.charAt(0).toUpperCase() +
              truck.truck_status.slice(1).toLowerCase()
              : ""
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>

  <div class="row to_container" *ngIf="!truckArray?.length && !trucksloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div *ngIf="last_page && last_page > 1 && TrucksReports" class="pagination">
    <button class="btn" [disabled]="truck_fetch_page == 1" (click)="truckspagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="truck_fetch_page == 1" (click)="truckspagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="truck_fetch_page > 0">{{ truck_fetch_page }}</a>
    </div>
    <button class="btn" [disabled]="last_page == truck_fetch_page" (click)="truckspagination('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == truck_fetch_page" (click)="truckspagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!---------------------- Drivers ---------------------->

<div class="dash" *ngIf="drivers">
  <div [class.spinner]="driversloading"></div>
  <form action="" [formGroup]="driversForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search">
            <input type="text" style="text-transform: capitalize" #driverTab
              (keyup)="onInputChange(driverTab.value, 'drivers')" [disabled]="isSearchDisabled"
              placeholder="Search Driver Name / Driver Number" (input)="transformToUppercaseDrivers($event)"
              (keyup.enter)="!isSearchDisabled && driverSearch(driverTab.value)" />

            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }" (click)="driverSearch(driverTab.value)" alt=""
              type="submit" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('drivers')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedDrivers">
          <a (click)="reportadvanced('drivers')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportCloseDrivers">
          <a (click)="reportClose('drivers')">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Truck No" formControlName="truckNumber">
                <mat-option *ngFor="let truckno of masterList.truck_data" value="{{ truckno }}">{{ truckno
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Driver Status" formControlName="driverStatus">
                <mat-option *ngFor="let driver_status of masterList.driverStatus" value="{{ driver_status }}">{{
                  driver_status }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a [class.disabled]="driversArray && driversArray.length === 0" [attr.disabled]="
                driversArray && driversArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  driversArray && driversArray.length === 0 ? 'none' : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="driverdownloadXl(driversdownloadArray)"
              [class.disabled]="driversArray && driversArray.length === 0" [attr.disabled]="
                driversArray && driversArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  driversArray && driversArray.length === 0 ? 'none' : 'auto'
              }">
              XLSX
            </a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="driverReset()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applyDriversFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>
    <div class="table-container" *ngIf="DriversReports">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="2">Driver ID</td>
            <td rowspan="2">Driver Name</td>
            <td rowspan="2">Driver Number</td>
            <td rowspan="2">Truck No</td>
            <td rowspan="2">Registered ON</td>
            <td rowspan="2">Driver Status</td>
          </tr>
          <tr></tr>
          <tr *ngFor="let drivers of driversArray">
            <td>{{ drivers.driver_id }}</td>
            <td>{{ drivers.username }}</td>
            <td>{{ drivers.mobile }}</td>
            <td>
              {{
              drivers.truckInfo[0]?.truck_number ||
              drivers.truckInfo?.truck_number
              }}
            </td>
            <td>{{ drivers.createdAt | date : "dd-MM-yyyy" }}</td>
            <!-- <td>{{ drivers.driver_trip_status }}</td> -->
            <td>
              {{
              drivers.driver_trip_status
              ? drivers.driver_trip_status.charAt(0).toUpperCase() +
              drivers.driver_trip_status.slice(1).toLowerCase()
              : ""
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
  <div class="row to_container" *ngIf="!driversArray?.length && !driversloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div *ngIf="last_page && last_page > 1 && DriversReports" class="pagination">
    <button class="btn" [disabled]="drivers_fetch_page == 1" (click)="driverspagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="drivers_fetch_page == 1" (click)="driverspagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="drivers_fetch_page > 0">{{
        drivers_fetch_page
        }}</a>
    </div>
    <button class="btn" [disabled]="last_page == drivers_fetch_page" (click)="driverspagination('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == drivers_fetch_page" (click)="driverspagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!---------------------- Orders ---------------------->

<div class="dash" *ngIf="orders">
  <div [class.spinner]="ordersloading"></div>
  <form action="" [formGroup]="ordersForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search">
            <input type="text" #orderTab (keyup)="onInputChange(orderTab.value, 'orders')" [disabled]="isSearchDisabled"
              placeholder="Search Trip ID" (input)="transformToUppercaseOrders($event)"
              (keyup.enter)="orderSearch(orderTab.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }"
              (click)="!isSearchDisabled && orderSearch(orderTab.value)" alt="" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('orders')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedOrders">
          <a (click)="reportadvanced('orders')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportCloseOrders">
          <a (click)="reportClose('orders')">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-2">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker1" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <input matInput [matDatepicker]="picker1" placeholder="From" formControlName="from_date"
                (click)="picker1.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker2" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <input matInput [matDatepicker]="picker2" placeholder="To" formControlName="to_date"
                (click)="picker2.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="From Location" formControlName="from_loc">
                <mat-option *ngFor="let fromloc of masterList.fromCityDetail" value="{{ fromloc }}">{{ fromloc
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="To Location" formControlName="to_loc">
                <mat-option *ngFor="let toloc of masterList.toCityDetail" value="{{ toloc }}">{{ toloc }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Trip ID" formControlName="trip_id">
                <mat-option *ngFor="let trip of masterList.tripNumbers" value="{{ trip }}">{{ trip }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Category" formControlName="veh_cat">
                <mat-option *ngFor="let truckcat of masterList.truck_category" value="{{ truckcat }}">{{ truckcat
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Weight" formControlName="weight">
                <mat-option *ngFor="let truckweight of masterList.truck_weight" value="{{ truckweight }}">{{ truckweight
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Triuck Owner Name" formControlName="truckowner_name">
                <mat-option *ngFor="let truckowner of masterList.truckonwerDetail" value="{{ truckowner }}">{{
                  truckowner }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a [class.disabled]="ordersArray && ordersArray.length === 0" [attr.disabled]="
                ordersArray && ordersArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  ordersArray && ordersArray.length === 0 ? 'none' : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="orderdownloadXl(ordersdownloadArray)" [class.disabled]="ordersArray && ordersArray.length === 0"
              [attr.disabled]="
                ordersArray && ordersArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  ordersArray && ordersArray.length === 0 ? 'none' : 'auto'
              }">XLSX</a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="resetOrders()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applyOrdersFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>
    <div class="table-container" *ngIf="OrdersReports">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="2">Date</td>
            <td rowspan="2">Order ID</td>
            <td rowspan="2">Trip ID</td>
            <td rowspan="2">Driver Name</td>
            <td rowspan="2">Truck Owner Name</td>
            <td rowspan="2">Vehicle Number</td>
            <td rowspan="2">Category</td>
            <td rowspan="2">Weight</td>
            <td rowspan="2">From</td>
            <td rowspan="2">To</td>
            <td rowspan="2">Order Price</td>
            <td rowspan="2">Order Status</td>
          </tr>
          <tr></tr>
          <tr *ngFor="let orders of ordersArray">
            <td>{{ orders.pickup_date | date : "dd-MM-yyyy" }}</td>
            <td>{{ orders.tripPaymentInfo[0]?.payment_id }}</td>
            <td>{{ orders.trip_id }}</td>
            <td>{{ orders.driverInfo[0]?.username }}</td>
            <td>
              {{
              orders.truckOwnerInfo[0]?.username ||
              orders.truckOwnerInfo?.username
              }}
            </td>
            <td>{{ orders.truckInfo[0]?.truck_number }}</td>
            <td>
              {{
              orders.truckCategoryInfo[0]?.truck_category_name ||
              orders.truckCategoryInfo?.truck_category_name
              }}
            </td>
            <td>
              {{
              orders.truckTypeInfo[0]?.truck_weight ||
              orders.truckTypeInfo?.truck_weight
              }}
            </td>
            <td>{{ orders.pickup_details.from_city_name }}</td>
            <td>{{ orders.dropoff_details.to_city_name }}</td>
            <td>
              {{ orders.tripPaymentInfo[0]?.price_details?.actual_price }}
            </td>
            <!-- <td>{{ orders.tripPaymentInfo[0]?.payment_status }}</td> -->
            <td>
              {{
              orders.tripPaymentInfo[0]?.payment_status
              ? orders.tripPaymentInfo[0]?.payment_status
              .charAt(0)
              .toUpperCase() +
              orders.tripPaymentInfo[0]?.payment_status
              .slice(1)
              .toLowerCase()
              : ""
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
  <div class="row to_container" *ngIf="!ordersArray?.length && !ordersloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div *ngIf="last_page && last_page > 1 && OrdersReports" class="pagination">
    <button class="btn" [disabled]="orders_fetch_page == 1" (click)="orderspagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="orders_fetch_page == 1" (click)="orderspagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="orders_fetch_page > 0">{{ orders_fetch_page }}</a>
    </div>
    <button class="btn" [disabled]="last_page == orders_fetch_page" (click)="orderspagination('last')">
      <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == orders_fetch_page" (click)="orderspagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!---------------------- CC ---------------------->

<div class="dash" *ngIf="corporatecustomers">
  <div [class.spinner]="corporateloading"></div>
  <form action="" [formGroup]="customerForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search" *ngIf="CID">
            <input type="text" #corporateTab (keyup)="onInputChange(corporateTab.value, 'corporate')"
              [disabled]="isSearchDisabled" placeholder="Search By CID No"
              (input)="transformToUppercaseCorporate($event)"
              (keyup.enter)="searchCorporateCustomer(corporateTab.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }" (click)="
                !isSearchDisabled && searchCorporateCustomer(corporateTab.value)
              " alt="" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('corporate')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
          <div class="search" *ngIf="Trip_Id">
            <input type="text" #corporateTab (keyup)="onInputChange(corporateTab.value, 'corporate')"
              [disabled]="isSearchDisabled" placeholder="Search Trip ID"
              (input)="transformToUppercaseCorporateCustomer($event)"
              (keyup.enter)="searchCorporate(corporateTab.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }" (click)="searchCorporate(corporateTab.value)"
              alt="" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('corporateCustomer')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedCustomers">
          <a (click)="reportadvanced('corporatecustomers')" [attr.disabled]="CID ? true : null"
            [ngClass]="{ 'search-icon-disabled': CID }" [ngStyle]="{
              'pointer-events': CID ? 'none' : 'auto'
            }">
            Advanced Search
          </a>
        </div>

        <div class="col-md-3" *ngIf="reportCloseCustomers">
          <a (click)="corporateCustomerClose()">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-2">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker1" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <input matInput [matDatepicker]="picker1" placeholder="From" formControlName="from_date"
                (click)="picker1.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker2" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <input matInput [matDatepicker]="picker2" placeholder="To" formControlName="to_date"
                (click)="picker2.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="From Location" formControlName="from_loc">
                <mat-option *ngFor="let fromloc of masterList.fromCityDetail" value="{{ fromloc }}">{{ fromloc
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="To Location" formControlName="to_loc">
                <mat-option *ngFor="let toloc of masterList.toCityDetail" value="{{ toloc }}">{{ toloc }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Trip ID" formControlName="trip_id">
                <mat-option *ngFor="let trip of masterList.tripNumbers" value="{{ trip }}">{{ trip }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Vehicle No" formControlName="vehicle_no">
                <mat-option *ngFor="let vehicle of masterList.truck_data" value="{{ vehicle }}">{{ vehicle
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="LRNo" formControlName="lr_no">
                <mat-option *ngFor="let lrno of masterList.lrNumbers" value="{{ lrno }}">{{ lrno }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="WO No" formControlName="wo_no">
                <mat-option *ngFor="let wono of masterList.workOrderNo" value="{{ wono }}">{{ wono }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Sales Order No" formControlName="sales_order">
                <mat-option *ngFor="let sales of masterList.salesOrderNumbers" value="{{ sales }}">{{ sales
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a [class.disabled]="customersArray && customersArray.length === 0" [attr.disabled]="
                customersArray && customersArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  customersArray && customersArray.length === 0
                    ? 'none'
                    : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="corporatedownloadXl(corporatedownloadArray)"
              [class.disabled]="customersArray && customersArray.length === 0" [attr.disabled]="
                customersArray && customersArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  customersArray && customersArray.length === 0
                    ? 'none'
                    : 'auto'
              }">XLSX</a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="resetCustomer()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applyCustomerFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>
    <div class="table1-container" *ngIf="customerReport">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="2">CID</td>
            <td rowspan="2">Customer Name</td>
            <td rowspan="2">Total Work Orders</td>
            <td rowspan="2">Total Trips</td>
            <td rowspan="2">Mobile Number</td>
          </tr>
          <tr></tr>
          <tr *ngFor="let customer of customersArray">
            <td class="cid" (click)="customerDetails(customer)" style="cursor: pointer; text-decoration: underline">
              {{ customer.user_id }}
            </td>
            <td>{{ customer.username }}</td>
            <td>{{ customer.workOrderInfo.length }}</td>
            <td>{{ customer.tripInfo?.length }}</td>
            <td>{{ customer.mobile }}</td>
          </tr>
        </tbody>
      </table>
      <br /><br />
    </div>

    <div class="row to_container" *ngIf="isNoRecordsFound">
      <h4 class="error_msg">No Records Found</h4>
    </div>

    <div class="table-container" *ngIf="customerDetailsEnable">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="2">Date</td>
            <td rowspan="2">WO No</td>
            <td rowspan="2">Trip No</td>
            <td rowspan="2">LR No</td>
            <td rowspan="2">From</td>
            <td rowspan="2">To</td>
            <td rowspan="2">Truck No</td>
            <td rowspan="2">DDC No</td>
            <td rowspan="2">Loaded QTY</td>
            <td rowspan="2">Price /Ton</td>
            <td rowspan="2">Unloaded QTY</td>
            <!-- <td rowspan="2">Final QTY</td> -->
            <td rowspan="2">Total Amount</td>
            <td rowspan="2">Sales Order No</td>
          </tr>
          <tr></tr>
          <tr *ngFor="let corporatecustomers of corporatecustomersArray">
            <td>{{ corporatecustomers.pickup_date | date : "dd-MM-yyyy" }}</td>
            <td>{{ corporatecustomers.workorderInfo[0]?.workorder_id }}</td>
            <td>{{ corporatecustomers.trip_id }}</td>
            <td>{{ corporatecustomers.workOrderOtherDetails?.lr_number }}</td>
            <td>{{ corporatecustomers.pickup_details.from_city_name }}</td>
            <td>{{ corporatecustomers.dropoff_details.to_city_name }}</td>
            <td>{{ corporatecustomers.truckInfo[0]?.truck_number }}</td>
            <td>{{ corporatecustomers.workOrderOtherDetails?.ddc_no }}</td>
            <td>
              {{ corporatecustomers.workOrderOtherDetails?.loading_point }}
            </td>
            <td>
              {{ corporatecustomers.workOrderOtherDetails?.price_per_ton }}
            </td>
            <td>
              {{ corporatecustomers.workOrderOtherDetails?.unloading_point }}
            </td>
            <!-- <td></td> -->
            <td>
              {{
              (
              corporatecustomers.workOrderOtherDetails?.unloading_point *
              corporatecustomers.workOrderOtherDetails?.price_per_ton ||
              corporatecustomers.workOrderOtherDetails?.loading_point *
              corporatecustomers.workOrderOtherDetails?.price_per_ton
              ).toFixed(2)
              }}
            </td>
            <td>
              {{ corporatecustomers.workOrderOtherDetails?.sales_order_number }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>

  <div *ngIf="corporateCustomer">
    <div *ngIf="last_page && last_page > 1; customerReport" class="pagination">
      <button class="btn" [disabled]="corporate_customer == 1" (click)="corporatepagination('-1')">
        <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button class="btn" [disabled]="corporate_customer == 1" (click)="corporatepagination('first')">
        <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
      </button>
      <div class="pages">
        <a class="page" *ngIf="corporate_customer > 0">{{
          corporate_customer
          }}</a>
      </div>
      <button class="btn" [disabled]="last_page == corporate_customer" (click)="corporatepagination('last')">
        <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
      </button>
      <button class="btn" [disabled]="last_page == corporate_customer" (click)="corporatepagination('1')">
        <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>
  <!-- After Click UID  -->

  <div *ngIf="corporateCustomeReport">
    <div *ngIf="last_page && last_page > 1" class="pagination">
      <button class="btn" [disabled]="corporate_fetch_page == 1" (click)="corporateCustomerpagination('-1')">
        <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button class="btn" [disabled]="corporate_fetch_page == 1" (click)="corporateCustomerpagination('first')">
        <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
      </button>
      <div class="pages">
        <a class="page" *ngIf="corporate_fetch_page > 0">{{
          corporate_fetch_page
          }}</a>
      </div>
      <button class="btn" [disabled]="last_page == corporate_fetch_page" (click)="corporateCustomerpagination('last')">
        <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
      </button>
      <button class="btn" [disabled]="last_page == corporate_fetch_page" (click)="corporateCustomerpagination('1')">
        <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>
</div>

<!---------------------- Transporter ---------------------->

<div class="dash" *ngIf="transporter">
  <div [class.spinner]="transporterloading"></div>
  <form action="" [formGroup]="transportForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search">
            <input type="text" #transporterTab (keyup)="onInputChange(transporterTab.value, 'transporter')"
              [disabled]="isSearchDisabled" placeholder="Search Truck Owner Name"
              (input)="transformToUppercaseTransporter($event)"
              (keyup.enter)="transporterSearch(transporterTab.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }" (click)="transporterSearch(transporterTab.value)"
              alt="" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('transporter')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedTransporter">
          <a (click)="reportadvanced('transporter')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportCloseTransporters">
          <a (click)="reportClose('transporter')">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-2">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker1" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <input matInput [matDatepicker]="picker1" placeholder="From" formControlName="from_date"
                (click)="picker1.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker2" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <input matInput [matDatepicker]="picker2" placeholder="To" formControlName="to_date"
                (click)="picker2.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="Trip ID" formControlName="trip_id">
                <mat-option *ngFor="let trip of masterList.tripNumbers" value="{{ trip }}">{{ trip }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="SalesOrderNo" formControlName="sales_order">
                <mat-option *ngFor="let sales of masterList.salesOrderNumbers" value="{{ sales }}">{{ sales
                  }}</mat-option>
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Triuck Owner Name" formControlName="truckowner_name">
                <mat-option *ngFor="let truckowner of masterList.truckonwerDetail" value="{{ truckowner }}">{{
                  truckowner }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="transporterdownload(transporterdownloadArray)" [class.disabled]="
                transporterArray && transporterArray.length === 0
              " [attr.disabled]="
                transporterArray && transporterArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  transporterArray && transporterArray.length === 0
                    ? 'none'
                    : 'auto'
              }">XLSX</a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="transporterReset()">
              Reset
            </button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applyTransporter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>

    <div class="row to_container" *ngIf="!transporterArray?.length && !transporterloading">
      <h4 class="error_msg">No Records Found</h4>
    </div>
    <div class="table-container" *ngIf="transporterReport">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="2">Date</td>
            <td rowspan="2">Trip</td>
            <td rowspan="2">Sales Order No</td>
            <td rowspan="2">Tax Invoice No</td>
            <td rowspan="2">LR No</td>
            <td rowspan="2">Vehicle No</td>
            <td rowspan="2">DDC No</td>
            <td rowspan="2">Truck Owner</td>
            <td rowspan="2">Loaded QTY</td>
            <td rowspan="2">Unloaded QTY</td>
            <td rowspan="2">Final QTY</td>
            <td rowspan="2">Price</td>
            <td rowspan="2">Total Amount</td>
          </tr>
          <tr></tr>
          <tr *ngFor="let transporter of transporterArray">
            <td>{{ transporter.pickup_date | date : "dd-MM-yyyy" }}</td>
            <td>{{ transporter.trip_id }}</td>
            <td>{{ transporter.workOrderOtherDetails?.sales_order_number }}</td>
            <td>{{ transporter.workOrderOtherDetails?.tax_invoice_no }}</td>
            <td>{{ transporter.workOrderOtherDetails?.lr_number }}</td>
            <td>{{ transporter.truckInfo[0]?.truck_number }}</td>
            <td>{{ transporter.workOrderOtherDetails?.ddc_no }}</td>
            <td>
              {{
              transporter.truckOwnerInfo[0]?.username ||
              transporter.truckOwnerInfo?.username
              }}
            </td>
            <td>
              {{
              transporter.workOrderOtherDetails?.loading_point ||
              transporter.trucktypeInfo[0]?.truck_weight
              }}
            </td>
            <td>{{ transporter.workOrderOtherDetails?.unloading_point }}</td>

            <!-- <td
              *ngIf="
                transporter.workOrderInfo[0] &&
                transporter.workOrderInfo[0].pay_as_load_quantity ==
                  'loaded_quantity'
              "
            >
              {{ transporter.workOrderOtherDetails?.loading_point }}
            </td>
            <td
              *ngIf="
                transporter.workOrderInfo[0] &&
                transporter.workOrderInfo[0].pay_as_load_quantity ==
                  'unloaded_quantity'
              "
            >
              {{ transporter.workOrderOtherDetails?.unloading_point || "NA" }}
            </td> -->

            <td>
              {{
              transporter?.workOrderOtherDetails?.price_per_ton
              ? transporter.workOrderOtherDetails.price_per_ton.toFixed(2)
              : "0.00"
              }}
            </td>
            <td>
              {{
              (transporter.workOrderOtherDetails?.unloading_point
              ? transporter.workOrderOtherDetails.unloading_point *
              transporter.workOrderOtherDetails?.price_per_ton
              : transporter.workOrderOtherDetails?.loading_point
              ? transporter.workOrderOtherDetails.loading_point *
              transporter.workOrderOtherDetails?.price_per_ton
              : 0
              ).toFixed(2)
              }}
            </td>
            <td>
              {{
              transporter.workOrderInfo.length === 0
              ? transporter.paymentInfo[0]?.price_details.total_amount.toFixed(
              2
              )
              : (
              transporter.workOrderOtherDetails?.unloading_point *
              transporter.workOrderOtherDetails?.price_per_ton ||
              transporter.workOrderOtherDetails?.loading_point *
              transporter.workOrderOtherDetails?.price_per_ton
              ).toFixed(2)
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>

  <div *ngIf="last_page && last_page > 1 && transporterReport" class="pagination">
    <button class="btn" [disabled]="transport_fetch_page == 1" (click)="transporterpagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="transport_fetch_page == 1" (click)="transporterpagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="transport_fetch_page > 0">{{
        transport_fetch_page
        }}</a>
    </div>
    <button class="btn" [disabled]="last_page == transport_fetch_page" (click)="transporterpagination('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == transport_fetch_page" (click)="transporterpagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!---------------------- Work Orders ---------------------->

<div class="dash" *ngIf="workorders">
  <div [class.spinner]="workorderloading"></div>
  <form action="" [formGroup]="workOrderForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search">
            <input type="text" #newItemWO (keyup)="onInputChange(newItemWO.value, 'workorders')"
              [disabled]="isSearchDisabled" placeholder="Search Work Order" (input)="transformToUppercaseWO($event)"
              (keyup.enter)="searchWorkOrder(newItemWO.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }"
              (click)="!isSearchDisabled && searchWorkOrder(newItemWO.value)" alt="" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('workorders')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedWorkOrders">
          <a (click)="reportadvanced('workorders')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportCloseWorkOrders">
          <a (click)="reportClose('workorders')">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <!-- <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select
                placeholder="Sales Order No"
                formControlName="salese_Order_Number"
              >
                <mat-option
                  *ngFor="let sales of masterList.salesOrderNumbers"
                  value="{{ sales }}"
                  >{{ sales }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div> -->
          <div class="col-md-2">
            <mat-form-field class="example-field">
              <mat-select placeholder="WorkOrder No" formControlName="work_Order_Number">
                <mat-option *ngFor="let wono of masterList.workOrderNo" value="{{ wono }}">{{ wono }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a [class.disabled]="
                workOrderssArray && workOrderssArray.length === 0
              " [attr.disabled]="
                workOrderssArray && workOrderssArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  workOrderssArray && workOrderssArray.length === 0
                    ? 'none'
                    : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="workorderdownloadXl(WodownloadArray)" [class.disabled]="
                workOrderssArray && workOrderssArray.length === 0
              " [attr.disabled]="
                workOrderssArray && workOrderssArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  workOrderssArray && workOrderssArray.length === 0
                    ? 'none'
                    : 'auto'
              }">XLSX</a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="resetWorkOrder()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applyWorkOrderFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>
    <div class="table-container" *ngIf="workOrdersReports">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="2">Date</td>
            <td rowspan="2">WO No</td>
            <!-- <td rowspan="2">Sales Order No</td> -->
            <td rowspan="2">Total Trips</td>
            <td rowspan="2">WO QTY</td>
            <td rowspan="2">Customer Name</td>
            <td rowspan="2">Loaded QTY</td>
            <td rowspan="2">Unloaded QTY</td>
            <td rowspan="2">Billing QTY</td>
            <td rowspan="2">Price</td>
            <td rowspan="2">Total Amount</td>
          </tr>
          <tr></tr>
          <tr *ngFor="let workorders of workOrderssArray">
            <td>{{ workorders.pickup_date | date : "dd-MM-yyyy" }}</td>
            <td>{{ workorders.workorder_id }}</td>
            <!-- <td>
              {{
                workorders.tripsInfo[0]?.workOrderOtherDetails
                  ?.sales_order_number ||
                  workorders.tripsInfo?.workOrderOtherDetails
                    ?.sales_order_number
              }}
            </td> -->
            <td>{{ getTripsInfoCount(workorders.tripsInfo) }}</td>
            <td>{{ workorders.total_tons }}</td>
            <td>
              {{
              workorders.customerInfo[0]?.username ||
              workorders.customerInfo?.username
              }}
            </td>
            <td>
              {{ getTotalLoadingPoint(workorders.tripsInfo).toFixed(2) }}
            </td>
            <td>
              {{ getTotalUnLoadingPoint(workorders.tripsInfo).toFixed(2) }}
            </td>
            <td>
              {{
              workorders.pay_as_load_quantity === "loaded_quantity"
              ? getTotalLoadingPoint(workorders.tripsInfo).toFixed(2)
              : workorders.pay_as_load_quantity === "unloaded_quantity"
              ? getTotalUnLoadingPoint(workorders.tripsInfo).toFixed(2)
              : "0.00"
              }}
            </td>
            <td>
              {{ workorders.price_per_ton }}
            </td>
            <td>
              {{ calculateTotalCost(workorders).toFixed(2) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
  <div class="row to_container" *ngIf="!workOrderssArray?.length && !workorderloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div *ngIf="last_page && last_page > 1 && workOrdersReports" class="pagination">
    <button class="btn" [disabled]="workorder_fetch_page == 1" (click)="workorderspagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="workorder_fetch_page == 1" (click)="workorderspagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="workorder_fetch_page > 0">{{
        workorder_fetch_page
        }}</a>
    </div>
    <button class="btn" [disabled]="last_page == workorder_fetch_page" (click)="workorderspagination('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == workorder_fetch_page" (click)="workorderspagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!-- ------------------- Pre Orders ---------------- -->
<div class="dash" *ngIf="pre_orders">
  <div [class.spinner]="preorderLoading"></div>
  <form [formGroup]="pre_orderForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search">
            <input type="text" #newItemPreorder (keyup)="onInputChange(newItemPreorder.value, 'preorder')"
              [disabled]="isSearchDisabled" placeholder="Search WO" (input)="transformToUppercaseWO($event)"
              (keyup.enter)="preOrderSearch(newItemPreorder.value)" />
            <img src="assets/img/search.svg" *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }" (click)="
                !isSearchDisabled && preOrderSearch(newItemPreorder.value)
              " alt="" />
            <span class="material-icons close-icon" *ngIf="!isSearching" (click)="clearSearch('preorder')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }">
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedWorkOrders">
          <a (click)="reportadvanced('workorders')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportCloseWorkOrders">
          <a (click)="reportClose('workorders')">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker1" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <input matInput [matDatepicker]="picker1" placeholder="From" formControlName="fromDate"
                (click)="picker1.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="picker2" class="ms-3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <input matInput [matDatepicker]="picker2" placeholder="To" formControlName="toDate"
                (click)="picker2.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="From Location" formControlName="fromLocation">
                <mat-option *ngFor="let fromloc of masterList.fromCityDetail" value="{{ fromloc }}">{{ fromloc
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="To Location" formControlName="toLocation">
                <mat-option *ngFor="let toloc of masterList.toCityDetail" value="{{ toloc }}">{{ toloc }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <!-- <mat-form-field class="example-field">
              <mat-select placeholder="WO/Q ID" formControlName="wo_qty">
                <mat-option>WO1</mat-option>
                <mat-option>WO2</mat-option>
                <mat-option>WO3</mat-option>
                <mat-option>WO4</mat-option>
                <mat-option>WO5</mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-form-field class="example-field">
              <mat-select placeholder="WO/Q ID" formControlName="woId">
                <mat-option *ngFor="let wono of masterList.workOrderNo" value="{{ wono }}">{{ wono }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Booking Type" formControlName="userType">
                <mat-option value="corporate">Corporate</mat-option>
                <mat-option value="customer">Customer</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Truck Category" formControlName="truckCategory">
                <mat-option *ngFor="let truckcat of masterList.truck_category" value="{{ truckcat }}">{{ truckcat
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a [class.disabled]="preorderArray && preorderArray.length === 0" [attr.disabled]="
                preorderArray && preorderArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  preorderArray && preorderArray.length === 0 ? 'none' : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="preorderdownloadXl(preOrderDownloadArray)"
              [class.disabled]="preorderArray && preorderArray.length === 0" [attr.disabled]="
                preorderArray && preorderArray.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  preorderArray && preorderArray.length === 0 ? 'none' : 'auto'
              }">XLSX</a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="resetPreOrder()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applypreordersFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>
    <div class="table-container" *ngIf="preOrderReports">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="2">PIN ID</td>
            <td rowspan="2">Date</td>
            <td rowspan="2">WO/Q ID</td>
            <td rowspan="2">Booking Type</td>
            <td rowspan="2">From</td>
            <td rowspan="2">To</td>
            <td rowspan="2">Truck Category</td>
            <td rowspan="2">Customer Price</td>
            <td rowspan="2">Cutoff Price</td>
            <td rowspan="2">No. of Bids Received</td>
            <td rowspan="2">Confirmed Trips</td>
            <td rowspan="2">Wo Qty</td>
            <td rowspan="2">Allocated Qty</td>
          </tr>
          <tr></tr>
          <tr *ngFor="let preOrder of preorderArray; let i = index">
            <td>{{ preOrder.pn_id }}</td>
            <td>{{ preOrder.pickup_date | date : "dd-MM-yyyy" }}</td>
            <td style="cursor: pointer" (click)="GoToWo(preOrder)">
              {{ preOrder.workorder_id }}
            </td>
            <td>{{ preOrder.userInfo.user_type }}</td>
            <td>{{ preOrder.pickup_details.from_city_name }}</td>
            <td>{{ preOrder.dropoff_details.to_city_name }}</td>
            <td>
              {{
              preOrder.truckCategoryInfo[0]?.truck_category_name ||
              preOrder.truckCategoryInfo?.truck_category_name
              }}
            </td>
            <td>
              {{
              preOrder.price_per_ton * preOrder.total_tons | number : "1.2-2"
              }}
            </td>
            <td>
              {{
              preOrder.price_per_ton *
              preOrder.total_tons *
              (1 - preOrder.workorder_margin / 100) | number : "1.2-2"
              }}
            </td>
            <!-- {{
              preOrder.price_per_ton *
                preOrder.total_tons *
                (1 -
                  preOrder.adminSettingsInfo[0]
                    ?.corporate_push_notification_margin /
                    100)
            }} -->
            <td>{{ preOrder.bidInfo.length || 0 }}</td>
            <td>{{ preOrder.confirmTripBidCount || 0 }}</td>
            <td>{{ preOrder.total_tons }}</td>
            <td>
              {{ preOrder.totalLoadingPoint | number : "1.2-2" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
  <div class="row to_container" *ngIf="!preorderLoading && !preorderArray?.length">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div *ngIf="last_page && last_page > 1 && preOrderReports" class="pagination">
    <button class="btn" [disabled]="pre_order_fetch_page == 1" (click)="preorderspagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="pre_order_fetch_page == 1" (click)="preorderspagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="pre_order_fetch_page > 0">{{
        pre_order_fetch_page
        }}</a>
    </div>
    <button class="btn" [disabled]="last_page == pre_order_fetch_page" (click)="preorderspagination('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == pre_order_fetch_page" (click)="preorderspagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!-- Pre order second screen -->

<div class="dash" *ngIf="pre_orders_2">
  <div [class.spinner]="preorderLoading1"></div>
  <form action="" [formGroup]="pre_orderForm1">
    <div class="trip-acoordion">
      <!-- <div class="row">
        <div class="col-md-6">
          <div class="search">
            <input
              type="text"
              #newItemPreorder1
              (keyup)="onInputChange(newItemPreorder1.value, 'workorders')"
              [disabled]="isSearchDisabled"
              placeholder="Search WO"
              (input)="transformToUppercaseWO($event)"
              (keyup.enter)="preOrder1Search(newItemPreorder1.value)"
            />
            <img
              src="assets/img/search.svg"
              *ngIf="isSearching"
              [ngClass]="{ 'search-icon-disabled': isSearchDisabled }"
              (click)="
                !isSearchDisabled && preOrder1Search(newItemPreorder1.value)
              "
              alt=""
            />
            <span
              class="material-icons close-icon"
              *ngIf="!isSearching"
              (click)="clearSearch('preorders1')"
              [ngClass]="{ 'disabled-span': isSearchDisabled }"
            >
              close
            </span>
          </div>
        </div>
        <div class="col-md-3" *ngIf="advancedWorkOrders">
          <a (click)="reportadvanced('workorders')">Advanced Search</a>
        </div>
        <div class="col-md-3" *ngIf="reportCloseWorkOrders">
          <a (click)="reportClose('workorders')">Close</a>
        </div>
      </div> -->
      <div *ngIf="searchData">
        <!-- <div class="row">
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Booking Type" formControlName="userType">
                <mat-option value="corporate">Corporate</mat-option>
                <mat-option value="customer">Customer</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Truck Category">
                <mat-option
                  *ngFor="let truckcat of masterList.truck_category"
                  value="{{ truckcat }}"
                  >{{ truckcat }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select
                placeholder="From Location"
                formControlName="fromLocation"
              >
                <mat-option
                  *ngFor="let fromloc of masterList.fromCityDetail"
                  value="{{ fromloc }}"
                  >{{ fromloc }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select
                placeholder="To Location"
                formControlName="toLocation"
              >
                <mat-option
                  *ngFor="let fromloc of masterList.fromCityDetail"
                  value="{{ fromloc }}"
                  >{{ fromloc }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div> -->
        <!-- <div class="row">
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="WO/Q ID" formControlName="woId">
                <mat-option
                  *ngFor="let wono of masterList.workOrderNo"
                  value="{{ wono }}"
                  >{{ wono }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div> -->
        <div class="row">
          <div class="col-md-1">
            <h5 class="download">Download:</h5>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a [class.disabled]="preorderArray1 && preorderArray1.length === 0" [attr.disabled]="
                preorderArray1 && preorderArray1.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  preorderArray1 && preorderArray1.length === 0
                    ? 'none'
                    : 'auto'
              }">PDF</a>
          </div>
          <div class="col-md-1" [ngClass]="{ 'search-icon-disabled': isNoDataFound }">
            <a (click)="preorder1downloadXl(preOrderDownloadArray1)"
              [class.disabled]="preorderArray1 && preorderArray1.length === 0" [attr.disabled]="
                preorderArray1 && preorderArray1.length === 0 ? true : null
              " [ngStyle]="{
                'pointer-events':
                  preorderArray1 && preorderArray1.length === 0
                    ? 'none'
                    : 'auto'
              }">XLSX</a>
          </div>
          <div class="col-md-2">
            <button class="reset_btn" (click)="resetPreOrder1()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" [disabled]="isApplyButtonDisabled" (click)="applypreOrder1OrderFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }"
          (click)="getActiveTab('corporatecustomers')">CC</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>
    <div class="table-container" *ngIf="preOrderReports">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td rowspan="2">PIN ID</td>
            <td rowspan="2">Date</td>
            <td rowspan="2">WO/Q ID</td>
            <td rowspan="2">TRUCK OWNER ID</td>
            <td rowspan="2">DRIVER ID</td>
            <td rowspan="2">TRUCK OWNER MOBILE</td>
            <td rowspan="2">DRIVER MOBILE</td>
            <td rowspan="2">TRUCK TYPE</td>
            <td rowspan="2">TR Price</td>
            <td rowspan="2">PIN STATUS</td>
            <td rowspan="2">TRIP ID</td>
          </tr>
          <tr></tr>
          <tr *ngFor="let preOrder of preorderArray1; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ preOrder.createdAt | date : "dd-MM-yyyy" }}</td>
            <td>{{ preOrder.workorderInfo[0]?.workorder_id }}</td>
            <td>{{ preOrder.truckownerInfo[0]?.truckowner_id }}</td>
            <td>{{ preOrder.driverInfo[0]?.driver_id }}</td>
            <td>{{ preOrder.truckownerInfo[0]?.mobile }}</td>
            <td>{{ preOrder.driverInfo[0]?.mobile }}</td>
            <td>{{ preOrder.truckTypeInfo[0]?.truck_weight }}</td>
            <td>{{ preOrder.price | number : "1.2-2" }}</td>
            <td>{{ preOrder.trip_status }}</td>
            <td>{{ preOrder.tripInfo[0]?.trip_id }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
  <div class="row to_container" *ngIf="!preorderArray1?.length && !preorderLoading1">
    <h4 class="error_msg">No Records Found.</h4>
  </div>

  <div *ngIf="last_page && last_page > 1 && preOrderReports1" class="pagination">
    <button class="btn" [disabled]="pre_order_fetch_page_1 == 1" (click)="preorderspagination1('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="pre_order_fetch_page_1 == 1" (click)="preorderspagination1('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="pre_order_fetch_page_1 > 0">{{
        pre_order_fetch_page_1
        }}</a>
    </div>
    <button class="btn" [disabled]="last_page == pre_order_fetch_page_1" (click)="preorderspagination1('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == pre_order_fetch_page_1" (click)="preorderspagination1('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>

<!---------------------- Driver Route Intelligence ---------------------->

<div class="dash" *ngIf="dri">
  <div [class.spinner]="driloading"></div>
  <form action="" [formGroup]="driForm">
    <div class="trip-acoordion">
      <div class="row">
        <div class="col-md-6">
          <div class="search" style="position: relative">
            <input type="text" #driTab placeholder="Search DRI" disabled />
            <img src="assets/img/search.svg" alt=""
              style="position: absolute; right: 40px; top: 50%; transform: translateY(-50%); cursor: not-allowed;" />
          </div>
        </div>
        <div class="col-md-2" *ngIf="advancedDRI">
          <a (click)="reportadvanced('dri')">Advanced Search</a>
        </div>
        <div class="col-md-2" *ngIf="driArray && driArray.length > 0">
          <button class="filter_btn"
            style="background-color: #28a745; margin-top: 0; padding: 5px 15px; font-size: 12px; white-space: nowrap; border-radius: 4px; display: flex; align-items: center; justify-content: center; min-width: 110px;"
            [disabled]="driExportLoading" (click)="dridownloadXl()">
            <span *ngIf="!driExportLoading">
              <i class="fa fa-download" style="margin-right: 5px;"></i> Export CSV
            </span>
            <span *ngIf="driExportLoading">
              <i class="fa fa-circle-o-notch fa-spin" style="margin-right: 5px;"></i> Exporting...
            </span>
          </button>
        </div>
        <div class="col-md-2" *ngIf="reportCloseDRI">
          <a (click)="reportClose('dri')">Close</a>
        </div>
      </div>
      <div *ngIf="searchData">
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="pickerDRI1" class="ms-3"></mat-datepicker-toggle>
              <mat-datepicker #pickerDRI1></mat-datepicker>
              <input matInput [matDatepicker]="pickerDRI1" placeholder="From Date" formControlName="from_date"
                (click)="pickerDRI1.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
              <mat-datepicker-toggle matSuffix [for]="pickerDRI2" class="ms-3"></mat-datepicker-toggle>
              <mat-datepicker #pickerDRI2></mat-datepicker>
              <input matInput [matDatepicker]="pickerDRI2" placeholder="To Date" formControlName="to_date"
                (click)="pickerDRI2.open()" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Route Type" formControlName="route_type">
                <mat-option value="past">Past</mat-option>
                <mat-option value="upcoming">Upcoming</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <mat-select placeholder="Truck Type" formControlName="truck_type">
                <mat-option *ngFor="let truck of masterList.truck_category" [value]="truck">{{truck}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <input matInput placeholder="From City" formControlName="from_city">
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <input matInput placeholder="To City" formControlName="to_city">
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <input matInput type="number" placeholder="Min Fare" formControlName="min_fare">
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="example-field">
              <input matInput type="number" placeholder="Max Fare" formControlName="max_fare">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <button class="reset_btn" (click)="resetDRI()">Reset</button>
          </div>
          <div class="col-md-2">
            <button class="filter_btn" (click)="applyDRIFilter()">Apply</button>
          </div>
        </div>
      </div>
      <div class="dash-trucks-top1">
        <a [ngClass]="{ active: report_type == 'todo' }" (click)="getActiveTab('todo')">To Do</a>
        <a [ngClass]="{ active: report_type == 'quote' }" (click)="getActiveTab('quote')">Quotes</a>
        <a [ngClass]="{ active: report_type == 'trips' }" (click)="getActiveTab('trips')">Trips</a>
        <a [ngClass]="{ active: report_type == 'payments' }" (click)="getActiveTab('payments')">Payments</a>
        <a [ngClass]="{ active: report_type == 'trucks' }" (click)="getActiveTab('trucks')">Trucks</a>
        <a [ngClass]="{ active: report_type == 'drivers' }" (click)="getActiveTab('drivers')">Drivers</a>
        <a [ngClass]="{ active: report_type == 'orders' }" (click)="getActiveTab('orders')">Orders</a>
        <a [ngClass]="{ active: report_type == 'corporatecustomers' }" (click)="getActiveTab('corporatecustomers')">C
          C</a>
        <a [ngClass]="{ active: report_type == 'transporter' }" (click)="getActiveTab('transporter')">Transporter</a>
        <a [ngClass]="{ active: report_type == 'workorders' }" (click)="getActiveTab('workorders')">Work Orders</a>
        <a [ngClass]="{ active: report_type == 'preorders' }" (click)="getActiveTab('preorders')">Pre Orders</a>
        <a [ngClass]="{ active: report_type == 'dri' }" (click)="getActiveTab('dri')">DRI</a>
      </div>
    </div>

    <div class="table-container" *ngIf="driReport">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tbody>
          <tr>
            <td (click)="sortData('id')" style="cursor: pointer; user-select: none;">
              ID
              <span style="font-size: 10px; margin-left: 5px;">{{ sortColumn === 'id' ? (sortDirection === 'asc' ? '▲' :
                '▼') : '↕' }}</span>
            </td>
            <td (click)="sortData('date')" style="cursor: pointer; user-select: none;">
              Date
              <span style="font-size: 10px; margin-left: 5px;">{{ sortColumn === 'date' ? (sortDirection === 'asc' ? '▲'
                : '▼') : '↕' }}</span>
            </td>
            <td (click)="sortData('from')" style="cursor: pointer; user-select: none;">
              From
              <span style="font-size: 10px; margin-left: 5px;">{{ sortColumn === 'from' ? (sortDirection === 'asc' ? '▲'
                : '▼') : '↕' }}</span>
            </td>
            <td (click)="sortData('to')" style="cursor: pointer; user-select: none;">
              To
              <span style="font-size: 10px; margin-left: 5px;">{{ sortColumn === 'to' ? (sortDirection === 'asc' ? '▲' :
                '▼') : '↕' }}</span>
            </td>
            <td (click)="sortData('category')" style="cursor: pointer; user-select: none;">
              Category
              <span style="font-size: 10px; margin-left: 5px;">{{ sortColumn === 'category' ? (sortDirection === 'asc' ?
                '▲' : '▼') : '↕' }}</span>
            </td>
            <td (click)="sortData('type')" style="cursor: pointer; user-select: none;">
              Type
              <span style="font-size: 10px; margin-left: 5px;">{{ sortColumn === 'type' ? (sortDirection === 'asc' ? '▲'
                : '▼') : '↕' }}</span>
            </td>
            <td (click)="sortData('material')" style="cursor: pointer; user-select: none;">
              Material
              <span style="font-size: 10px; margin-left: 5px;">{{ sortColumn === 'material' ? (sortDirection === 'asc' ?
                '▲' : '▼') : '↕' }}</span>
            </td>
            <td (click)="sortData('vehicle_no')" style="cursor: pointer; user-select: none;">
              Vehicle No
              <span style="font-size: 10px; margin-left: 5px;">{{ sortColumn === 'vehicle_no' ? (sortDirection === 'asc'
                ? '▲' : '▼') : '↕' }}</span>
            </td>
            <td (click)="sortData('to_name')" style="cursor: pointer; user-select: none;">
              TO Name
              <span style="font-size: 10px; margin-left: 5px;">{{ sortColumn === 'to_name' ? (sortDirection === 'asc' ?
                '▲' : '▼') : '↕' }}</span>
            </td>
            <td (click)="sortData('to_no')" style="cursor: pointer; user-select: none;">
              TO No
              <span style="font-size: 10px; margin-left: 5px;">{{ sortColumn === 'to_no' ? (sortDirection === 'asc' ?
                '▲' : '▼') : '↕' }}</span>
            </td>
          </tr>
          <tr *ngFor="let route of driArray">
            <td>{{ route.offline_route_unique_id }}</td>
            <td>{{ route.date | date : "dd-MM-yyyy" }}</td>
            <td>{{ route.fromLocation?.from_city_name }}</td>
            <td>{{ route.toLocation?.to_city_name }}</td>
            <td>{{ route.truck_category }}</td>
            <td>{{ route.route_type | titlecase }}</td>
            <td>{{ route.material }}</td>
            <td>{{ route.truck_no }}</td>
            <td>{{ route.truck_owner_name }}</td>
            <td>{{ route.truck_owner_number }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row to_container" *ngIf="!driArray?.length && !driloading">
      <h4 class="error_msg">No Records Found.</h4>
    </div>
  </form>

  <div *ngIf="last_page && last_page > 1 && driReport" class="pagination">
    <button class="btn" [disabled]="dri_fetch_page == 1" (click)="driPagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="dri_fetch_page == 1" (click)="driPagination('first')">
      <img src="assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="dri_fetch_page > 0">{{ dri_fetch_page }}</a>
    </div>
    <button class="btn" [disabled]="last_page == dri_fetch_page" (click)="driPagination('last')">
      <img src="assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == dri_fetch_page" (click)="driPagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>